// fontrenamed as cardiuma-M  23-08-24 Dev Srini

const styles = theme => ({
    loginCard: {
        maxWidth: '504px',
        maxHeight: '355px',
        borderRadius: '14px',
        background: 'var(--b, #FFF)',
        // Srini 07-01-25
        "@media only screen and (min-width: 300px) and (max-width: 600px)": {
            margin: '200px auto 0', 
            width: '80%',
        },
        
        "@media only screen and (min-width: 601px) and (max-width: 900px)": {
            margin: '250px auto 0', 
        },

        "@media only screen and (min-width: 901px) and (max-width: 1200px)": {
            margin: '250px auto 0', 
        },

        "@media only screen and (min-width: 1201px) and (max-width: 1536px)": {
            margin: '250px auto 0', 
        },

        "@media only screen and (min-width: 1537px)": {
            margin: '250px auto 0', 
        },
    },

    loginHeading: {
        color: '#333',
        textAlign: 'center',
        fontFamily: 'cardiuma-M  ! important ',
        fontSize: '28px ! important ',
        fontStyle: 'normal ! important ',
        fontWeight: '500 ! important ',
        lineHeight: '2.5 ! important ',
    },

    buttonCard: {
        display: 'flex',
        width: '400px',
        height: '48px',
        padding: '8px 24px ! important',
        justifyContent: 'center ! important',
        alignItems: 'center ! important',
        gap: '10px',
        flexShrink: 0,
        borderRadius: '8px ! important',
        background: 'var(--CTA, #F74542 ) ! important',
        // Srini 07-01-25
        "@media only screen and (min-width: 300px) and (max-width: 600px)": {
            width: '60vw',
        }
    },

    buttonText: {
        color: 'var(--b, #FFF)',
        fontFamily: 'cardiuma-M  ! important',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '500',
        lineHeight: 'normal'
    },

    errTxt: {
        color: '#F74542 !important',
        fontFamily: 'cardiuma-regular !important',
        fontSize: '12px !important',
        padding: '1px 0px 0px 10px'
    }
})

export default styles
